import utils from "Sources/utils/utils";
import request from "Sources/services/request";

let AssignmentService = {};

((AssignmentService) =>
{
  AssignmentService.getAllAssignments = function()
  {
    return request.get({
      url:  utils.getServiceUrl("/intermediate_assignments"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON
    })
      .then((data) =>
      {
        let rtrnData = null;

        if(utils.isNotNull(data) && data.result === "success" && data.data)
        {
          rtrnData = data.data;
        }

        return rtrnData;
      });
  };

  AssignmentService.getAssignmentFile = function(key)
  {
    return request.get({
      url:  utils.getServiceUrl("/intermediate_assignments/" + key + "/file"),
      cache: false
    })
      .then((data) =>
      {
        let rtrnData = null;

        if(utils.isNotNull(data) && data.result === "success" && data.data)
        {
          rtrnData = data.data;
        }

        return rtrnData;
      });
  };

})(AssignmentService);

module.exports = AssignmentService;



// WEBPACK FOOTER //
// ./app/js/services/intermediate-assignment-service.js